import { DropDown } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import {
    CliendDocsFilter,
    ClientBlock,
    ClientBlockAdd,
    ClientCrossLink,
    ClientDocsInfo,
    ClientEditingInfo,
    ClientFilter,
    ClientGeneral,
    ClientHistory,
    ClientManualPaymentInfo,
    ClientManualPaymentResponse,
    ClientOrder,
    ClientTable,
    ClientWithdrawOrder
} from 'models/api/client';
import { RequestDocsInfo } from 'models/api/order';
import { ClientPaymentInfo } from 'models/api/payment';
import ResTable from 'models/api/table';
import { Key } from 'react';

const controller = '/clients';

export const getClientsList = async (axios: AxiosInstance, params?: ClientFilter) => {
    const response = await axios.get<ResTable<ClientTable>>(controller, {
        params: { ...params },
    });
    return response.data;
};

export const getClientsExcel = async (axios: AxiosInstance, params: ClientFilter) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const deleteClient = async (axios: AxiosInstance, id: number | string) =>
    await axios.delete(controller + `/${id}`);

export const getClient = async (
    axios: AxiosInstance,
    id: number | string,
    orderId?: number | null
) => {
    const response = await axios.get<ClientGeneral>(controller + `/${id}`, {
        params: { orderId: orderId },
    });
    return response.data;
};

export const getClientPaymentsInfo = async (
    axios: AxiosInstance,
    id: number | string,
    orderId?: number
) => {
    const response = await axios.get<ClientPaymentInfo[]>(controller + `/detail/payments/${id}`, {
        params: { orderId: orderId },
    });
    return response.data;
};

export const getClientDocumentsInfo = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<ClientDocsInfo>(controller + `/detail/documents/${id}`);
    return response.data;
};

export const getCrossLinks = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<ClientCrossLink[]>(controller + `/cross-links/${id}`);
    return response.data;
};

export const getBlocks = async (axios: AxiosInstance, clientId: number | string) => {
    const response = await axios.get<ClientBlock[]>(controller + `/blocks/${clientId}`);
    return response.data;
};

export const changeBlocks = async (
    axios: AxiosInstance,
    clientId: string | number,
    blocks: ClientBlockAdd[]
) => {
    await axios.put<ClientBlock[]>(controller + `/blocks/${clientId}`, blocks);
};

export const getOrders = async (axios: AxiosInstance, clientId: number | string) => {
    const response = await axios.get<ClientOrder[]>(controller + `/orders/${clientId}`);
    return response.data;
};

export const getHistory = async (axios: AxiosInstance, clientId: number | string) => {
    const response = await axios.get<ClientHistory>(controller + `/history/${clientId}`);
    return response.data;
};

export const getClientFile = async (axios: AxiosInstance, id: number | string) => {
    const response = await axios.get<Blob>(controller + `/file/${id}`, {
        responseType: 'arraybuffer',
    });
    return response.data;
};

export const getBankTypes = async (axios: AxiosInstance) => {
    const response = await axios.get<DropDown[]>(controller + `/bankTypes`);
    return response.data;
};

export const getBankInfo = async (axios: AxiosInstance, bankTypeId?: Key | null) => {
    const response = await axios.get<DropDown[]>(controller + `/bankInfo`, {
        params: { bankTypeId },
    });
    return response.data;
};

export const updateClientData = async (
    axios: AxiosInstance,
    id: number | string,
    info: ClientEditingInfo
) => {
    await axios.post(controller, info, {
        params: { id: id },
    });
};

export const updateClientDataOnManualCheck = async (
    axios: AxiosInstance,
    id: number | string,
    info: ClientEditingInfo
) => {
    await axios.post(controller + '/manualCheck', info, {
        params: { id: id },
    });
};

export const requestDocs = async (
    axios: AxiosInstance,
    id: number,
    orderId: number,
    info: RequestDocsInfo[]
) => {
    const { data } = await axios.post(controller + `/detail/documents/request/${id}`, info, {
        params: { orderId: orderId },
    });
    return data;
};

export const updatePhoto = async (axios: AxiosInstance, info: FormData) => {
    const { data } = await axios.post<number>(controller + `/updatePhoto`, info);
    return data;
};

export const getClientDocumentsInfoByFilter = async (
    axios: AxiosInstance,
    filter: CliendDocsFilter
) => {
    const params = { ...filter };
    const response = await axios.get<ClientDocsInfo>(controller + `/getClientPhoto`, { params });
    return response.data;
};

export const isRepeat = async (axios: AxiosInstance, id: number) => {
    const response = await axios.get<boolean>(controller + `/${id}/is-repeat`);
    return response.data;
};

export const sendManualPayment = async (
    axios: AxiosInstance,
    cleintManualPayment: ClientManualPaymentInfo
) => {
    const { data } = await axios.post<ClientManualPaymentResponse>(controller + `/manualPayment`, cleintManualPayment );
    return data;
};

export const getWithdrawOrders = async (axios: AxiosInstance, clientId: number | string) => {
    const response = await axios.get<ClientWithdrawOrder[]>(controller + `/orders/withdrawList/${clientId}`);
    return response.data;
};
